export const hasNonNullValue = (...values: unknown[]): boolean => {
  return values.some((value) => value !== null);
};
